import { useEffect, useState } from "react"
import { toBoolean } from "../helpers/Helper";

const useAuth = () => {
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        setIsAdmin(toBoolean(localStorage.getItem("admin")));
      }, [localStorage.getItem("admin")]);

    return { isAdmin }
}

export { useAuth }